<template>
  <div>
    <ul>
      <li class="contenedor-tarjetas" v-for="match in partidos" :key="match.id">
        <TarjetaPartido :partido="match" @goDetail="propagateGoDetail"></TarjetaPartido>
      </li>
    </ul>
  </div>
</template>

<script>
import TarjetaPartido from './TarjetaPartido.vue'
export default {
  components: {
    TarjetaPartido
  },
  props: {
    partidos: []
  },
  methods: {
    goFicha (id) {
      this.$store.dispatch('fetchFichaClub', id)
    },
    propagateGoDetail (idPartido) {
      this.$emit('goDetailPartido', idPartido)
    }
  },
  mounted () {

  }
}
</script>

<style scoped>
.contenedor-tarjetas{
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
li{
  list-style: none;
}
ul{
  padding: 0;
}
</style>
